import { ReactOverview } from "gojs-react";
import go from "gojs";

const Component = (props: any) => {
  const { diagrams, show } = props;
  const $ = go.GraphObject.make;

  return (
    <>
      {show ? (
        <ReactOverview
          initOverview={() =>
            $(go.Overview, {
              contentAlignment: go.Spot.Center,
              // observed: diagrams
            })
          }
          divClassName="overview-component"
          // style?: React.CSSProperties;
          observedDiagram={diagrams}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Component;
